import React from 'react';
import { Table } from 'react-bootstrap';

// Functions
import { getTime, getDate } from '../../../../functions/hreadableDate';
import differenceDate from '../../../../functions/differenceDate';

const ClockList = ({ list }) => {

    const returnDates = (clockIn, clockOut) => {
        const clockInDate = getDate(clockIn);
        const clockOutDate = getDate(clockOut);
        
        if(clockInDate === clockOutDate || !clockOut)
            return `${clockInDate}`;
        else
            return `${clockInDate} - ${clockOutDate}`;
        
            
    }

    return (
        <Table striped bordered hover>
            <thead>
                <tr>
                    <th>Fecha</th>
                    <th>Entrada</th>
                    <th>Salida</th>
                    <th>Empezó Lunch</th>
                    <th>Termino Lunch</th>
                    <th>Tiempo Trabajando</th>
                    <th>Tiempo en Lunch</th>
                </tr>
            </thead>
            <tbody>
                {list.map(item => (
                    <tr key={item._id}>
                        <td>{returnDates(item.clockInTime, item.clockOutTime)}</td>
                        <td>{getTime(item.clockInTime)}</td>
                        <td>{item.clockOutTime && getTime(item.clockOutTime)}</td>
                        <td>{item.lunchInTime && getTime(item.lunchInTime)}</td>
                        <td>{item.lunchOutTime && getTime(item.lunchOutTime)}</td>
                        <td>{item.clockInTime && item.clockOutTime && differenceDate(item.clockInTime, item.clockOutTime, item.lunchInTime, item.lunchOutTime)}</td>
                        <td>{item.lunchInTime && item.lunchOutTime && differenceDate(item.lunchInTime, item.lunchOutTime)}</td>
                    </tr>
                ))}
            </tbody>
        </Table>
    )
};

export default ClockList;